/* Storybook of Us — book renderer.
   ElrBook.pages(data) returns the ordered list of page HTML strings.
   Used by the storefront builder (assets/elr-book.js) and the print
   generator (book/build_book.py), so both render the same book.
   Illustrations are resolved through ElrBook.artUrl(key); set
   window.ElrArtBase to the folder that holds elr-art-<key>.jpg. */
(function (root) {
  var COVERS = { Rose: '#b8435e', Midnight: '#2d3453', Sage: '#6f8f76', Sand: '#b98f5e' };
  var MAX_REASONS = 36;
  var MIN_REASONS = 20;
  var MIN_PAGES = 32;  // interior pages, excluding the cover

  // Illustration library: key -> label shown in the picture picker.
  var ART = {
    coffee: 'Morning coffee', cooking: 'Cooking', breakfast: 'Breakfast', dinner: 'Date night', takeout: 'Takeout night',
    cake: 'Celebrations', movienight: 'Movie night', reading: 'Quiet evenings', music: 'Music', guitar: 'Songs',
    roadtrip: 'Road trips', travel: 'Adventures', balloon: 'Dreams', beach: 'The beach', camping: 'Campfires',
    mountains: 'Hikes', bicycle: 'Bike rides', picnic: 'Picnics', bench: 'Walks', rain: 'Rainy days',
    home: 'Home', plants: 'Growing together', moon: 'Night sky', phone: 'Texts', letter: 'Love notes',
    games: 'Game night', dog: 'The dog', cat: 'The cat', ducks: 'Family', workshop: 'Fixing things',
    care: 'Taking care', hug: 'Hugs', lovebirds: 'Together', flowers: 'Flowers', sunflowers: 'Sunshine',
    gifts: 'Surprises', balloons: 'Fun', rings: 'Forever', christmas: 'Holidays', lighthouse: 'Safe harbour',
    wreath: 'Love'
  };
  // First match wins. Keep specific themes above broad ones.
  var RULES = [
    [/\b(coffee|latte|espresso|cappuccino|tea|cuppa|mugs?)\b/i, 'coffee'],
    [/\b(pancakes?|breakfast|brunch|waffles?|toast)\b|sunday morning/i, 'breakfast'],
    [/\b(pizza|fries|takeout|take-out|burgers?|snacks?|junk food|chips)\b/i, 'takeout'],
    [/\b(dinners?|date nights?|restaurants?|wine|candles?)\b/i, 'dinner'],
    [/\b(cook\w*|kitchen|bak(e|es|ing)|recipes?|meals?|chef)\b/i, 'cooking'],
    [/\b(cakes?|birthdays?|celebrat\w*|party|parties|anniversar\w*)\b/i, 'cake'],
    [/\b(movies?|films?|netflix|tv|series|popcorn|couch|sofa)\b/i, 'movienight'],
    [/\b(books?|read|reading|library)\b/i, 'reading'],
    [/\b(guitar|sing|sings|singing|songs?|voice)\b/i, 'guitar'],
    [/\b(music|playlists?|danc\w*|records?|concerts?|hum|humming)\b/i, 'music'],
    [/\b(car|cars|drive|drives|driving|road ?trips?|passenger)\b/i, 'roadtrip'],
    [/\b(beach|sea|ocean|swim\w*|sand|waves?)\b/i, 'beach'],
    [/\b(travel\w*|trips?|holidays?|vacations?|flights?|planes?|abroad|adventures?|explor\w*)\b/i, 'travel'],
    [/\b(camp\w*|campfire|tents?|marshmallows?)\b/i, 'camping'],
    [/\b(hik\w*|mountains?|climb\w*|trails?)\b/i, 'mountains'],
    [/\b(bikes?|cycl\w*)\b/i, 'bicycle'],
    [/\b(picnics?|park|outdoors)\b/i, 'picnic'],
    [/\b(walks?|walking|stroll\w*|bench)\b/i, 'bench'],
    [/\b(safe|calm|anchor|guide|there for me)\b/i, 'lighthouse'],
    [/\b(rain\w*|umbrella|storms?)\b/i, 'rain'],
    [/\b(texts?|texting|phone|calls?|messages?)\b/i, 'phone'],
    [/\b(notes?|letters?|cards?|write|wrote|writing)\b/i, 'letter'],
    [/\b(games?|board games?|competitive|puzzles?)\b/i, 'games'],
    [/\b(dogs?|pupp(y|ies)|pup)\b/i, 'dog'],
    [/\b(cats?|kittens?|kitty)\b/i, 'cat'],
    [/\b(kids?|child|children|family|mum|mom|mother|dad|father|parents?|baby)\b/i, 'ducks'],
    [/\b(fix\w*|build\w*|tools?|repair\w*|handy|garage)\b/i, 'workshop'],
    [/\b(sick|ill|look after|looked after|take care|took care|soup)\b/i, 'care'],
    [/\b(hugs?|hugging|cuddl\w*|arms)\b/i, 'hug'],
    [/\b(plants?|garden\w*)\b/i, 'plants'],
    [/\b(home|house|apartment|flat)\b/i, 'home'],
    [/\b(night|nights|stars?|moon|sleep\w*|bed|dreams?)\b/i, 'moon'],
    [/\b(marr\w*|wedding|rings?|forever|vows?|propos\w*)\b/i, 'rings'],
    [/\b(christmas|winter|snow)\b/i, 'christmas'],
    [/\b(gifts?|presents?|surpris\w*)\b/i, 'gifts'],
    [/\b(laugh\w*|jokes?|funny|silly|fun|smil\w*|puns?)\b/i, 'balloons'],
    [/\b(flowers?|roses?|bouquet)\b/i, 'flowers'],
    [/\b(sun|sunshine|sunny|bright|light up|happy|joy)\b/i, 'sunflowers'],
    [/\b(future|believe|goals?|wildest)\b/i, 'balloon'],
    [/\b(hands?|kiss\w*|together|close)\b/i, 'lovebirds']
  ];
  var FALLBACK = ['lovebirds', 'flowers', 'hug', 'sunflowers', 'moon', 'balloons', 'bench', 'letter', 'home', 'wreath', 'plants', 'gifts'];

  var PROMPTS = [
    'The way you laugh at your own jokes before you finish telling them.',
    'You always save me the last bite.',
    'How you make every ordinary day feel like an adventure.',
    'The way you look at me when you think I’m not watching.',
    'You remember the tiny things I mention once.',
    'Your terrible singing in the car, which I secretly love.',
    'You make the best coffee, and you always make me one too.',
    'The way you hold my hand without even thinking about it.',
    'You believe in me on the days I don’t.',
    'How you get excited about the smallest things.',
    'You’re my favourite person to do nothing with.',
    'The way you say my name.',
    'You never let me go to bed angry.',
    'Your hugs fix almost everything.',
    'You make me laugh until I can’t breathe.',
    'How patient you are with me.',
    'You dance in the kitchen like nobody is watching.',
    'The way you care for the people you love.',
    'You always know when something is wrong.',
    'How you make our home feel like home.',
    'Your ridiculous morning hair.',
    'You text me just to say you’re thinking of me.',
    'The way you tell stories with your hands.',
    'You make me want to be a better person.',
    'How brave you are, even when you’re scared.',
    'You still give me butterflies.',
    'The way you get lost in a good book.',
    'You’re kind to strangers when nobody is looking.',
    'Your cooking, even the experiments.',
    'You always let me have the warm side of the bed.',
    'The little notes you leave for me.',
    'How you celebrate my wins like they’re your own.',
    'You make long drives feel short.',
    'The way your eyes crinkle when you smile.',
    'You never judge me.',
    'How you calm me down with one look.',
    'Our inside jokes that nobody else understands.',
    'You’re the first person I want to tell everything.',
    'How hard you work for our family.',
    'You make Sunday mornings my favourite.',
    'The way you sneeze.',
    'You always find the good in people.',
    'How you hum while you cook.',
    'You let me steal your hoodies.',
    'The way you say goodnight.',
    'You make me feel safe.',
    'How you light up a room.',
    'You laugh at my worst puns.',
    'The way you take care of me when I’m sick.',
    'You chose me, and you keep choosing me.',
    'Your honesty, even when it’s hard.',
    'How you turn chores into games.',
    'You always have a snack for me.',
    'The way you fall asleep in the middle of movies.',
    'You make plans for our future with me.',
    'How curious you are about everything.',
    'You forgive easily and love fully.',
    'The adventure of our first trip together.',
    'The moment I knew you were the one.',
    'The way you look in the morning light.',
    'You are my calm in every storm.',
    'How you make friends everywhere you go.',
    'You never stop surprising me.',
    'The way you hug me from behind.',
    'You listen, really listen.',
    'How you get competitive over board games.',
    'You make me feel like the luckiest person alive.',
    'The way you say “we” instead of “I”.',
    'You taught me how to slow down.',
    'How you always share your fries.',
    'You make the world feel softer.',
    'The way you smell after a shower.',
    'You never forget our anniversary.',
    'How you encourage my wildest ideas.',
    'You love my family like your own.',
    'The way you kiss my forehead.',
    'You are my best friend.',
    'How you handle hard days with grace.',
    'You put up with my weird habits.',
    'The playlist you made just for me.',
    'You always walk on the traffic side of the pavement.',
    'How you make every holiday magical.',
    'You make me feel beautiful.',
    'The way you get excited about dessert.',
    'You taught me what love really means.',
    'How you remember my coffee order.',
    'You always make time for me.',
    'The way we can talk for hours.',
    'You make silence comfortable.',
    'How you check the doors are locked every night.',
    'You bring out the best in me.',
    'The way you cheer loudest at everything I do.',
    'You never let me feel alone.',
    'How you say sorry first.',
    'You make me proud every single day.',
    'The way you love our little rituals.',
    'You are the reason I smile at my phone.',
    'How gentle you are.',
    'You make growing older together sound like fun.',
    'The way you say “I love you” every day.',
    'You taught me to ride a bike and never let go too early.',
    'How you always had a plaster and a hug ready.',
    'You showed me how to be kind.',
    'The Sunday phone calls I look forward to all week.',
    'You always pick up, no matter the time.',
    'You’re the friend who shows up with snacks and no questions.'
  ];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function artUrl(key) {
    var base = root.ElrArtBase || '';
    return base + 'elr-art-' + key + '.jpg';
  }
  // Full-page scenes (bright, full-bleed) share keys with ART.
  function sceneUrl(key) { return (root.ElrArtBase || '') + 'elr-scene-' + key + '.jpg'; }
  function sceneThumb(key) { return (root.ElrArtBase || '') + 'elr-scene-' + key + '-t.jpg'; }
  function img(key, cls) {
    return '<img class="' + cls + '" src="' + esc(artUrl(key)) + '" alt="" loading="lazy" decoding="async">';
  }
  function titleFor(recipient) {
    if (/mom|mum|mother/i.test(recipient || '')) return 'The Storybook of Us, Mom';
    if (/dad|father/i.test(recipient || '')) return 'The Storybook of Us, Dad';
    return 'The Storybook of Us';
  }
  function sizeClass(t) {
    var n = (t || '').length;
    return n > 150 ? ' is-s' : n > 80 ? ' is-m' : '';
  }
  // Pick an illustration for each reason: explicit choice, then keywords, then a rotating fallback.
  function assignArt(reasons, chosen) {
    // Title, dedication and closing pages already use these three.
    var used = { wreath: true, letter: true, lovebirds: true }, fb = 0, out = [];
    reasons.forEach(function (r, i) {
      var key = chosen && ART[chosen[i]] ? chosen[i] : null;
      if (!key) {
        for (var k = 0; k < RULES.length; k++) {
          if (RULES[k][0].test(r) && !used[RULES[k][1]]) { key = RULES[k][1]; break; }
        }
      }
      if (!key) {
        for (var n = 0; n < FALLBACK.length; n++) {
          var f = FALLBACK[(fb + n) % FALLBACK.length];
          if (!used[f]) { key = f; fb = (fb + n + 1) % FALLBACK.length; break; }
        }
      }
      if (!key) key = FALLBACK[fb++ % FALLBACK.length];
      used[key] = true;
      out.push(key);
    });
    return out;
  }
  // Arched frame holding the customer's painted portrait (or a placeholder until it's painted).
  function portrait(d) {
    return '<div class="elr-bp__portrait">' + (d.portraitUrl
      ? '<img src="' + esc(d.portraitUrl) + '" alt="">'
      : img('lovebirds', 'elr-bp__pimg') + '<span class="elr-bp__ptag">Your painted portrait</span>') + '</div>';
  }
  function page(type, inner, extra) {
    return '<div class="elr-bp elr-bp--' + type + (extra || '') + '"><div class="elr-bp__in">' + inner + '</div></div>';
  }
  function clean(data) {
    var pairs = (data.reasons || []).map(function (r, i) { return [String(r || '').trim(), (data.art || [])[i] || null]; })
      .filter(function (p) { return p[0]; }).slice(0, MAX_REASONS);
    return {
      to: String(data.to || '').trim() || 'You',
      from: String(data.from || '').trim() || 'Me',
      recipient: data.recipient || '',
      cover: COVERS[data.cover] ? data.cover : 'Rose',
      dedication: String(data.dedication || '').trim(),
      reasons: pairs.map(function (p) { return p[0]; }),
      art: pairs.map(function (p) { return p[1]; }),
      portrait: !!data.portrait,
      portraitUrl: String(data.portraitUrl || '')
    };
  }

  // ---------- story ----------
  // The book is a guided story: the customer finishes ten sentence starters written for
  // their relationship, and each answer becomes a two-page spread (illustration + story).
  var KINDS = ['couple', 'parent', 'child', 'friend', 'sibling', 'grandparent'];
  function kind(recipient) {
    var r = recipient || '';
    if (/grand/i.test(r)) return 'grandparent';
    if (/mom|mum|mother|dad|father/i.test(r)) return 'parent';
    if (/\bson\b|daughter|child/i.test(r)) return 'child';
    if (/sister|brother|sibling/i.test(r)) return 'sibling';
    if (/friend/i.test(r)) return 'friend';
    return 'couple';
  }
  // [key, starter, example, heading, closing line, default art]
  var Q = {
    couple: [
      ['begin', 'It all began', 'at a tiny coffee shop on a rainy Tuesday', 'How it began', 'I didn’t know it yet, {to}, but that was the start of everything.', 'coffee'],
      ['place', 'Our favourite place in the world is', 'the little beach where we watched the sunset on our first trip', 'Our place', 'Wherever we go, part of me stays there with you.', 'beach'],
      ['together', 'Together, we love', 'cooking pasta far too late on Sunday nights', 'Our favourite things', 'Ordinary moments, made extraordinary because they’re ours.', 'cooking'],
      ['little', 'I love the little way you', 'leave notes in my coat pockets', 'The little things', 'It’s the small things that say the most.', 'letter'],
      ['laugh', 'You always make me laugh when you', 'sing every song wrong in the car', 'The laughter', 'Nobody makes me laugh the way you do.', 'balloons'],
      ['hard', 'When things got hard, you', 'held my hand and told me we’d figure it out together', 'Through it all', 'You were my calm in every storm.', 'lighthouse'],
      ['adventure', 'Our greatest adventure was', 'getting completely lost in Rome and loving every minute', 'Our adventures', 'With you, even getting lost feels like finding something.', 'travel'],
      ['taught', 'You taught me', 'that home is a person, not a place', 'What you taught me', 'I’m a better person because of you.', 'reading'],
      ['love', 'What I love most about you is', 'your big, kind heart and the way you look after everyone', 'Why it’s you', 'Of all the reasons, this one is my favourite.', 'sunflowers'],
      ['future', 'One day, I hope we', 'grow old together on a porch somewhere warm', 'Happily ever after', 'And I can’t wait to find out what happens next.', 'balloon']
    ],
    parent: [
      ['begin', 'My earliest memory of you is', 'you singing to me while you made breakfast', 'In the beginning', 'I’ve carried that memory with me my whole life.', 'breakfast'],
      ['place', 'The place that always feels like home with you is', 'your kitchen, with the radio on', 'Home', 'Wherever you are, that’s home.', 'home'],
      ['together', 'Together, we love', 'long walks and even longer talks', 'Our favourite things', 'Some of my happiest hours were spent right there beside you.', 'bench'],
      ['little', 'I love the little way you', 'always make sure I’ve eaten', 'The little things', 'You show your love in a hundred small ways.', 'care'],
      ['laugh', 'You always make me laugh when you', 'tell the same joke for the hundredth time', 'The laughter', 'Your laugh is still my favourite sound.', 'balloons'],
      ['hard', 'When things got hard, you', 'dropped everything and came to find me', 'Always there', 'You never once let me face it alone.', 'lighthouse'],
      ['adventure', 'My favourite adventure with you was', 'that road trip where we ate ice cream every single day', 'Our adventures', 'I’d do it all again in a heartbeat.', 'roadtrip'],
      ['taught', 'You taught me', 'to always be kind, even when it’s hard', 'What you taught me', 'I see you in everything I do.', 'reading'],
      ['love', 'What I love most about you is', 'how you love everyone as if they were your own', 'Why it’s you', 'I hope you know how much you are loved in return.', 'sunflowers'],
      ['future', 'One day, I hope we', 'take that trip to the seaside you’ve always talked about', 'The next chapter', 'Our story isn’t finished, and I can’t wait for the rest of it.', 'balloon']
    ],
    child: [
      ['begin', 'The day you arrived,', 'the whole world went quiet and I fell in love', 'The day you arrived', 'Nothing has been the same since, and I wouldn’t change a thing.', 'moon'],
      ['place', 'Our favourite place together is', 'the park with the big red slide', 'Our place', 'I hope you always remember it the way I do.', 'picnic'],
      ['together', 'Together, we love', 'baking cookies and eating half the dough', 'Our favourite things', 'These are the days I’ll treasure forever.', 'cooking'],
      ['little', 'I love the little way you', 'hum to yourself when you’re concentrating', 'The little things', 'Every little part of you is wonderful.', 'music'],
      ['laugh', 'You always make me laugh when you', 'do your silly dance in the kitchen', 'The laughter', 'Your giggle is the best sound in the world.', 'balloons'],
      ['hard', 'I’m so proud of the way you', 'kept going, even when it was really hard', 'So proud of you', 'You are braver than you know.', 'mountains'],
      ['adventure', 'Our greatest adventure was', 'the camping trip when it rained all weekend', 'Our adventures', 'Every adventure is better with you.', 'camping'],
      ['taught', 'You taught me', 'to see the world with fresh, curious eyes', 'What you taught me', 'I thought I’d be the one teaching you.', 'reading'],
      ['love', 'What I love most about you is', 'your curious mind and your enormous heart', 'Why it’s you', 'Never change who you are.', 'sunflowers'],
      ['future', 'I hope that you', 'always remember how loved you are', 'For your future', 'Wherever life takes you, I’ll be cheering you on.', 'balloon']
    ],
    friend: [
      ['begin', 'We became friends when', 'we got stuck together in the worst group project ever', 'How it began', 'Best accident that ever happened to me.', 'coffee'],
      ['place', 'Our favourite place is', 'that little café where we talk for hours', 'Our place', 'Some places are just better with you in them.', 'bench'],
      ['together', 'Together, we love', 'terrible reality TV and very good snacks', 'Our favourite things', 'Doing nothing with you is one of my favourite things.', 'movienight'],
      ['little', 'I love the little way you', 'always know exactly what to say', 'The little things', 'You make it look easy, but it isn’t.', 'phone'],
      ['laugh', 'You always make me laugh when you', 'tell a story with your whole body', 'The laughter', 'Nobody makes me laugh like you do.', 'balloons'],
      ['hard', 'When things got hard, you', 'showed up with ice cream and no questions', 'Always there', 'That’s what real friendship looks like.', 'care'],
      ['adventure', 'Our greatest adventure was', 'the road trip where absolutely everything went wrong', 'Our adventures', 'Still the best trip of my life.', 'roadtrip'],
      ['taught', 'You taught me', 'that it’s okay to ask for help', 'What you taught me', 'I’m braver because of you.', 'reading'],
      ['love', 'What I love most about you is', 'how fiercely loyal you are', 'Why it’s you', 'Everyone should have a friend like you.', 'sunflowers'],
      ['future', 'One day, I hope we', 'are two old friends still laughing at the same jokes', 'The next chapter', 'Here’s to the rest of our story.', 'balloon']
    ]
  };
  // Siblings and grandparents share most questions with friends and parents.
  Q.sibling = Q.friend.map(function (q) { return q.slice(); });
  Q.sibling[0] = ['begin', 'Growing up, we', 'built blanket forts and blamed each other for everything', 'Growing up', 'You were my first friend, and my favourite.', 'home'];
  Q.grandparent = Q.parent.map(function (q) { return q.slice(); });
  Q.grandparent[0] = ['begin', 'My favourite memory with you is', 'baking in your kitchen on Saturday mornings', 'Our memories', 'I hope I never forget a single moment.', 'cooking'];
  Q.grandparent[1] = ['place', 'The place I love being with you is', 'your garden, surrounded by your roses', 'Your place', 'It will always be one of my favourite places in the world.', 'plants'];

  var INTRO = {
    couple: 'Once upon a time, there was {to}, and there was {from}. This is the story of how two people became an “us”, and all the little reasons it could only ever have been you.',
    parent: 'Once upon a time, there was {to}, and there was {from}. This is the story of the person who taught me what love looks like.',
    child: 'Once upon a time, there was {from}, and then there was {to}, and everything changed. This is your story, and it’s one of my favourites.',
    friend: 'Once upon a time, there was {to}, and there was {from}. This is the story of a friendship, and all the reasons you’re my person.',
    sibling: 'Once upon a time, there was {to}, and there was {from}. This is the story of growing up side by side, and everything that came after.',
    grandparent: 'Once upon a time, there was {to}, and there was {from}. This is the story of all the love you’ve given, and all the love that grew from it.'
  };
  var ENDING = {
    couple: 'And they lived happily, messily, wonderfully, ever after.',
    parent: 'And the love you gave me is the love I’ll carry, always.',
    child: 'And I will love you, always and forever, no matter what.',
    friend: 'And they stayed friends, through everything, forever after.',
    sibling: 'And they stayed side by side, forever after.',
    grandparent: 'And your love will live on in all of us, forever after.'
  };
  function questions(recipient) { return Q[kind(recipient)]; }
  var NUMBER = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];
  var KEEPSAKES = [
    ['A photo of us', null], ['The day we met', 'letter'], ['Our song', 'music'], ['The best day we’ve ever had', 'balloon'],
    ['Something only we find funny', 'balloons'], ['Places we still want to go', 'travel'], ['Our little traditions', 'christmas'],
    ['What I wish for you', 'sunflowers'], ['A letter to future us', 'letter'], ['Things that remind me of you', 'flowers'],
    ['Our next adventure', 'mountains'], ['A day I’d love to live again', 'picnic']
  ];
  function fill(t, d) { return t.replace(/\{to\}/g, esc(d.to)).replace(/\{from\}/g, esc(d.from)); }
  var LOWER_OK = /^(at|in|on|the|a|an|we|you|your|my|our|when|with|getting|how|that|to|always|every|long|his|her|their|it|going|being|cooking|singing|dancing|baking|walking|making|watching|playing|reading|taking|telling|leaving|holding|showing|dropping|kept|grow|are|take|built|baking|terrible|very|big|little|just|never|still)\b/i;
  function sentence(starter, answer) {
    var raw = String(answer || '').trim(), tail = (raw.match(/[?!]+$/) || ['.'])[0];
    var a = raw.replace(/[\s.!?…]+$/, '');
    if (a && /^[A-Z][a-z]/.test(a) && LOWER_OK.test(a)) a = a.charAt(0).toLowerCase() + a.slice(1);
    var end = tail;
    return starter + ' ' + a + end;
  }
  function storyTitle(d) {
    return 'The Story of ' + d.to + ' & ' + d.from;
  }
  function av(d, cls) {
    var A = root.ElrAvatar;
    if (!A) return '';
    return '<div class="' + cls + '">' + A.couple(d.av.to, d.av.from) + '</div>';
  }
  // Night-time or dark scenes get a light caption.
  var DARK = { music: 1, moon: 1, camping: 1, takeout: 1, phone: 1, balloons: 1, dinner: 1, lighthouse: 1 };
  // How the two characters stand in each scene.
  var POSE = {
    music: 'cheer', balloons: 'cheer', cake: 'cheer', gifts: 'cheer', balloon: 'cheer', sunflowers: 'cheer',
    hug: 'hug', moon: 'hug', beach: 'hug', lighthouse: 'hug', rings: 'hug', care: 'hug', christmas: 'hug', lovebirds: 'hug', rain: 'hug',
    travel: 'wave', roadtrip: 'wave', mountains: 'wave', cooking: 'wave', home: 'wave', dog: 'wave', letter: 'wave', flowers: 'wave',
    movienight: 'side', reading: 'side', games: 'side', phone: 'side', cat: 'side', workshop: 'side'
  };
  // Speech bubbles for each chapter: [who speaks, line]. {to} and {from} become their names.
  var BUBBLE = {
    begin: ['from', 'Hello, {to}!'], place: ['to', 'I love it here.'], together: ['from', 'Again tomorrow?'],
    little: ['to', 'You noticed!'], laugh: ['to', 'Stop, {from}, I can’t breathe!'], hard: ['from', 'I’m right here, {to}.'],
    adventure: ['to', 'Where to next, {from}?'], taught: ['from', 'Thank you, {to}.'], love: ['from', 'You’re one of a kind, {to}.'],
    future: ['to', 'I can’t wait, {from}!']
  };
  var BUBBLE_KIND = {
    couple: { begin: ['from', 'Hi… I’m {from}.'], love: ['from', 'I love you, {to}.'], future: ['to', 'Forever, {from}?'] },
    child: { begin: ['from', 'Hello, little {to}.'], hard: ['from', 'So proud of you, {to}!'], future: ['from', 'Go get them, {to}!'] }
  };
  var ENDCAP = { couple: 'To be continued…', parent: 'Always and forever', child: 'Always and forever', friend: 'Friends forever',
    sibling: 'Side by side, forever', grandparent: 'Always and forever' };
  function scene(d, key, caption, bubble) {
    var A = root.ElrAvatar, fig = A ? '<div class="elr-bp__pose">' + A.couple(d.av.to, d.av.from, { pose: POSE[key] || 'hands', heart: false }) + '</div>' : '';
    var bub = bubble ? '<p class="elr-bp__bub elr-bp__bub--' + bubble[0] + '">' + fill(bubble[1], d) + '</p>' : '';
    return page('scene', '<img class="elr-bp__bg" src="' + esc(sceneUrl(key)) + '" alt="" loading="lazy" decoding="async">' +
      '<h2 class="elr-bp__scap">' + esc(caption) + '</h2>' + fig + bub, DARK[key] ? ' is-dark' : '');
  }

  // Illustration for each question: the customer's pick, else a match for their words, else the default.
  function storyArt(qs, answers, chosen) {
    var used = { wreath: true, lovebirds: true, letter: false }, out = {};
    qs.forEach(function (q) {
      var key = chosen && ART[chosen[q[0]]] ? chosen[q[0]] : null;
      if (!key) {
        var t = answers[q[0]] || '';
        for (var k = 0; k < RULES.length; k++) { if (RULES[k][0].test(t) && !used[RULES[k][1]]) { key = RULES[k][1]; break; } }
      }
      if (!key && !used[q[5]]) key = q[5];
      if (!key) key = FALLBACK.filter(function (f) { return !used[f]; })[0] || q[5];
      used[key] = true; out[q[0]] = key;
    });
    return out;
  }

  // Interior is always at least MIN_PAGES and an even number of pages.
  function pages(raw) {
    var d = clean(raw);
    d.av = raw.av || {};
    var answers = raw.answers || {};
    var little = (raw.little || []).map(function (x) { return String(x || '').trim(); }).filter(Boolean).slice(0, 15);
    var color = COVERS[d.cover];
    var wrap = function (html) { return html.replace('class="elr-bp ', 'style="--c:' + color + '" class="elr-bp '); };
    var kd = kind(d.recipient), qs = Q[kd], title = storyTitle(d);
    var arts = storyArt(qs, answers, raw.storyArt || {});
    var out = [];
    var P = function (type, html, extra) { out.push(Object.assign({ type: type, html: wrap(html) }, extra || {})); };

    P('cover', page('cover',
      '<img class="elr-bp__bg" src="' + esc(artUrl('cover-' + d.cover.toLowerCase() + '-a5')) + '" alt="">' + av(d, 'elr-bp__cav') +
      '<div class="elr-bp__plate"><p class="elr-bp__label">A story for ' + esc(d.to) + '</p>' +
      '<h2 class="elr-bp__title">' + esc(title) + '</h2>' +
      '<p class="elr-bp__sub">written with love by ' + esc(d.from) + '</p></div>', ' elr-bp--cover-' + d.cover.toLowerCase() + ' has-figure'));
    P('title', page('title',
      av(d, 'elr-bp__tav') + '<p class="elr-bp__names">' + esc(d.to) + ' <span>&amp;</span> ' + esc(d.from) + '</p>' +
      '<h2 class="elr-bp__title">' + esc(title) + '</h2><p class="elr-bp__sub">A true story, in ' + qs.length + ' chapters</p>'));
    // Page 2 (left, facing the dedication)
    P('colophon', page('colophon', '<div class="elr-bp__cap"><p class="elr-bp__sub">This book was made especially for</p><p class="elr-bp__names">' + esc(d.to) + '</p>' +
      '<p class="elr-bp__sub">with love, by ' + esc(d.from) + '</p><div class="elr-bp__rule"></div><p class="elr-bp__fine">Storybook of Us</p></div>'));
    var ded = d.dedication || ('I made this so you’d never have to wonder. This is our story, as I see it, written down so you can keep it forever.');
    P('dedication', page('dedication', img('letter', 'elr-bp__art') +
      '<div class="elr-bp__cap"><p class="elr-bp__greet">Dear ' + esc(d.to) + ',</p><p class="elr-bp__body">' + esc(ded) + '</p><p class="elr-bp__sign">With love, ' + esc(d.from) + '</p></div>'));
    // Opening spread
    P('scene', scene(d, 'wreath', 'Once upon a time…'));
    P('story', page('story', '<div class="elr-bp__cap"><p class="elr-bp__label">Our story begins</p><p class="elr-bp__story">' + fill(INTRO[kd], d) + '</p></div>'));
    // One spread per question
    qs.forEach(function (q, i) {
      var a = answers[q[0]] || q[2];
      var bub = (raw.bubbles && raw.bubbles[q[0]] != null) ? [((BUBBLE_KIND[kd] || {})[q[0]] || BUBBLE[q[0]])[0], raw.bubbles[q[0]]]
        : ((BUBBLE_KIND[kd] || {})[q[0]] || BUBBLE[q[0]]);
      if (bub && !String(bub[1]).trim()) bub = null;
      P('scene', scene(d, arts[q[0]], q[3], bub), { q: q[0] });
      P('chapter', page('chapter',
        '<div class="elr-bp__cap"><p class="elr-bp__label">Chapter ' + NUMBER[i] + ' · ' + esc(q[3]) + '</p>' +
        '<p class="elr-bp__story elr-bp__story--big">' + esc(sentence(q[1], a)) + '</p>' +
        '<div class="elr-bp__rule"></div><p class="elr-bp__sub">' + fill(q[4], d) + '</p></div>'), { q: q[0] });
    });
    // Ending spread
    P('scene', scene(d, 'lovebirds', ENDCAP[kd] || 'Happily ever after'));
    P('ending', page('ending', '<div class="elr-bp__cap"><p class="elr-bp__label">The end</p><p class="elr-bp__story elr-bp__story--big">' +
      fill(ENDING[kd], d) + '</p><div class="elr-bp__rule"></div><p class="elr-bp__sub">…or rather, just the beginning.</p></div>'));
    // Optional list of little things, five per page
    var perPage = Math.ceil(little.length / Math.ceil(little.length / 5 || 1)) || 5;  // spread items evenly
    for (var li = 0; li < little.length; li += perPage) {
      P('little', page('little', img('flowers', 'elr-bp__kart') +
        '<p class="elr-bp__label">' + (li ? 'And a few more' : 'Little things I love about you') + '</p><ul class="elr-bp__list">' +
        little.slice(li, li + perPage).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>'));
    }
    // Keepsake pages to write in by hand, filling the book to MIN_PAGES (always an even count).
    var interior = out.length - 1;
    var need = Math.max(2, MIN_PAGES - interior);
    if ((interior + need) % 2) need++;
    for (var k = 0; k < need; k++) {
      var ks = KEEPSAKES[k % KEEPSAKES.length];
      P('keepsake', page('keepsake', (ks[1] ? img(ks[1], 'elr-bp__kart') : '') + '<p class="elr-bp__label">' + esc(ks[0]) + '</p>' +
        '<p class="elr-bp__hint">' + (ks[1] ? 'Fill this in together, by hand' : 'Stick in a favourite photo of you two') + '</p>' +
        (ks[1] ? '<div class="elr-bp__lines"></div>' : '<div class="elr-bp__frame"><span>Your photo here</span></div>')));
    }
    return out;
  }

  root.ElrBook = {
    COVERS: COVERS, ART: ART, sceneUrl: sceneUrl, sceneThumb: sceneThumb, bubble: function (recipient, key) { return (BUBBLE_KIND[kind(recipient)] || {})[key] || BUBBLE[key]; }, PROMPTS: PROMPTS, MAX_REASONS: MAX_REASONS, MIN_REASONS: MIN_REASONS,
    pages: pages, esc: esc, clean: clean, artUrl: artUrl, assignArt: assignArt,
    questions: questions, kind: kind, storyArt: storyArt, sentence: sentence
  };
})(typeof window !== 'undefined' ? window : this);
